import {
  animate,
  keyframes,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const scaleHeightAndFadeAnimation = trigger('scaleHeightAndFade', [
  transition(':enter', [
    // Scale height and fade in
    animate(
      '250ms ease-in',
      keyframes([
        style({ height: '0', opacity: 0, overflow: 'hidden', offset: 0 }),
        style({ height: '*', opacity: 0.5, offset: 0.5 }),
        style({ height: '*', opacity: 1, offset: 1 }),
      ]),
    ),
  ]),
  transition(':leave', [
    // Scale height and fade out
    animate(
      '250ms ease-out',
      keyframes([
        style({ height: '*', opacity: 1, offset: 0 }),
        style({ height: '*', opacity: 0.5, offset: 0.5 }),
        style({ height: '0', opacity: 0, overflow: 'hidden', offset: 1 }),
      ]),
    ),
  ]),
]);
